import { render, staticRenderFns } from "./personalized-assignments.vue?vue&type=template&id=4f469e74&scoped=true&"
import script from "./personalized-assignments.vue?vue&type=script&lang=js&"
export * from "./personalized-assignments.vue?vue&type=script&lang=js&"
import style0 from "./personalized-assignments.vue?vue&type=style&index=0&id=4f469e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f469e74",
  null
  
)

export default component.exports